/**
 * CancelButton Component
 *
 * UI/Aesthetics: Light gray button with contained styling, typically used for cancel actions
 * Functions: Standard button functionality with click handlers, disabled states, etc.
 */

import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface CancelButtonProps
  extends Omit<React.ComponentProps<typeof Button>, 'size'> {
  children?: React.ReactNode;
  /** Size of the button - supports MUI 'small' for compatibility */
  size?: 'default' | 'sm' | 'lg' | 'icon' | 'small';
}

export const CancelButton: React.FC<CancelButtonProps> = ({
  children,
  className,
  variant = 'secondary',
  size,
  ...props
}) => {
  const getButtonSize = (): 'default' | 'sm' | 'lg' | 'icon' => {
    return size === 'small'
      ? 'sm'
      : (size as 'default' | 'sm' | 'lg' | 'icon') || 'default';
  };

  return (
    <Button
      variant={variant}
      size={getButtonSize()}
      className={cn('', className)}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CancelButton;
